/**
 * SignerImage Component
 * Displays signer image on the right side when a signer is selected
 */

import { i18n } from '../utils/i18n.js';

export class SignerImage {
  constructor({ container, signer }) {
    this.container = container;
    this.signer = signer;
  }

  render() {
    if (!this.signer || (!this.signer.img1B64 && !this.signer.img2B64)) {
      this.container.innerHTML = '';
      return;
    }
    
    const img1Html = this.signer.img1B64 
      ? `<div class="border-b border-gray-100">
          <div class="px-4 py-3">
            <span class="text-sm font-semibold text-gray-700">${i18n.t('signerImage.photo')}</span>
          </div>
          <div class="px-4 pb-3">
            <div class="rounded-lg overflow-hidden border border-gray-200">
              <img 
                src="data:image/jpeg;base64,${this.signer.img1B64}" 
                alt="${this.escapeHtml(this.signer.label)}"
                class="w-full h-auto max-h-40 object-contain"
              />
            </div>
          </div>
        </div>`
      : '';
    
    const img2Html = this.signer.img2B64 
      ? `<div class="border-b border-gray-100">
          <div class="px-4 py-3">
            <span class="text-sm font-semibold text-gray-700">${i18n.t('signerImage.signature')}</span>
          </div>
          <div class="px-4 pb-3">
            <div class="rounded-lg overflow-hidden border border-gray-200 bg-white">
              <img 
                src="data:image/jpeg;base64,${this.signer.img2B64}" 
                alt="${i18n.t('signerImage.signature')} - ${this.escapeHtml(this.signer.label)}"
                class="w-full h-auto max-h-24 object-contain"
              />
            </div>
          </div>
        </div>`
      : '';
    
    this.container.innerHTML = `
      <div class="h-full bg-white rounded-lg shadow-lg lg:shadow-sm border border-gray-200 flex flex-col">
        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h2 class="text-lg font-semibold text-gray-800">${i18n.t('signerImage.title')}</h2>
          <button id="wsp-close-image-sidebar" class="lg:hidden p-1 hover:bg-gray-100 rounded-md transition-colors">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="flex-1 overflow-y-auto">
          <div class="border-b border-gray-100">
            <div class="px-4 py-3">
              <p class="text-sm font-medium text-gray-700">${this.escapeHtml(this.signer.label)}</p>
              <div class="mt-1">
                ${this.signer.isSigned ? `<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">${i18n.t('signers.signed')}</span>` : `<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">${i18n.t('signers.pending')}</span>`}
              </div>
            </div>
          </div>
          ${img1Html}
          ${img2Html}
        </div>
      </div>
    `;
    
    this.attachCloseButton();
  }

  attachCloseButton() {
    const closeBtn = this.container.querySelector('#wsp-close-image-sidebar');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        const imageSidebar = document.querySelector('#wsp-image-sidebar');
        const imageOverlay = document.querySelector('#wsp-image-overlay');
        
        if (imageSidebar) {
          imageSidebar.classList.add('translate-x-full');
        }
        if (imageOverlay) {
          imageOverlay.classList.add('hidden');
        }
      });
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
